<ng-container *transloco="let t">
  <div class="d-flex flex-column">
    <div class="race-grid-item" [class.is-last]="isLast">
      <!--      <app-races-header [race]="race"></app-races-header>-->
      <div class="race-grid-item--body">
        <div class="item-info d-flex align-items-start flex-column">
          <div class="w-100-sm-auto-xxl fs-15">
            <p class="large trim-text-third-line race-title">
              <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
                                   [srLabel]="race?.nameSr" [siLabel]="race?.nameSlo" [bsLabel]="race?.nameBs"
                                   [defaultLanguage]="eventItem?.defaultLanguage" [languages]="languages"/>
            </p>

            <div class="pt-3 pb-3 d-flex align-items-center">
              <div class="pe-2 d-flex" *ngIf="race?.length">
                <div class="badge darkRed-badge d-inline-flex h-24">
                  {{ race?.length | raceLengthFormat:translocoService.getActiveLang(): "km" }}
                </div>
              </div>
              <div *ngIf="race?.sport" class="badge fs-15 d-inline-flex h-24 text-uppercase">
                {{ t("app.common.sports." + race?.sport) }}
              </div>
            </div>

            <div class="mb-1 d-flex flex-row justify-content-between align-items-center“">
              <div class="d-inline-flex align-items-center">
                <img src="assets/icons/icons-alt/calendar-04.svg" alt="">
                <p class="ps-2">{{
                    race && race.raceStart ? (race!.raceStart |
                        localizedDate:'short')
                      : '-'
                  }}</p>
              </div>
            </div>


            <div class="race-details mb-2 mb-md-3">
              <div class="race-details__item">
                <p>{{ t("race.details.registration.until") }}</p>
                <p> {{
                    race
                      ? (race.registrationEnd | localizedDate:'short')
                      : '-'
                  }} </p>
              </div>
              <div class="race-details__item">
                <p> {{ t("event.item.participants") }}</p>
                <p> {{
                    race | raceCompetitorCountFormat
                  }} </p>
              </div>
              <div class="race-details__item"
                   *ngIf="(race | raceAscentDescentFormat) as formattedValue"
                   [hidden]="!formattedValue">
                <p>{{ t('race.grid.elevation') }}</p>
                <p>{{ formattedValue }}</p>
              </div>
            </div>
            <ng-container *ngIf="race && (raceCommercialItems | raceCommercialItemsMinPriceFormat:currencyLabel) as minPrice">
              <p *ngIf="minPrice !== '-' && minPrice" class="min-price">
                {{ t("race.details.price.from") }}: <span>{{ minPrice }}</span>
              </p>
            </ng-container>
          </div>
          <div class="d-flex flex-nowrap justify-content-end w-100 pt-20">
            <div class="ps-2">
              <a href="javascript:void(0);"
                 class="text-decoration-underline text-uppercase anchor-btn anchor-btn--small"
                 (click)="onMore()">
                {{ t('race.details.more.details') }}
              </a>
            </div>
            @if (!hideRegistration) {
              <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [text]="t('race.grid.register')"
                              [borderColor]="'var(--teal-500)'" (onClickCallback)="onRegister()"
                              [isDisabled]="!race?.open" [buttonHeight]="currentWindowWidth > 992 ? '' : '32px'"
                              [fontSize]="currentWindowWidth > 992 ? '' : '14px'"></app-button-alt>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
